import { downgradeInjectable } from '@angular/upgrade/static';
import { SearchClientService } from '@mode/algolia/domain';
import { DataIndexClientService } from '@mode/queries/schemas/data-access';
import { FeatureFlag, MigrationFlag } from '@mode/shared/contract-common';
import { LaunchDarklyFlagsDataService } from '@mode/shared/util-feature-flags';
import * as angular from 'angular';
import { AlgoliaSuggestionService } from '~/plugins/ace/completion-providers/algolia-suggestion.service';
import { DataIndexSuggestionService } from '~/plugins/ace/completion-providers/data-index-suggestion.service';
import { DualDispatchSuggestionService } from '~/plugins/ace/completion-providers/dual-dispatch-suggestion.service';

export const DowngradedSharedDataAccessAlgoliaModule = angular
  .module('downgraded-shared-data-access-algolia', [])
  .service('DataIndexClientService', downgradeInjectable(DataIndexClientService))
  .service('SearchClientService', downgradeInjectable(SearchClientService))
  .factory('SuggestionService', [
    'LaunchDarklyFlagsDataService',
    '$injector',
    (launchDarkly: LaunchDarklyFlagsDataService, $injector: angular.auto.IInjectorService) => {
      switch (launchDarkly.variation<MigrationFlag>(FeatureFlag.OpenSearchAutocompleteMigration, 'off')) {
        case 'shadow':
          return $injector.get('DualDispatchSuggestionService');
        case 'live':
        case 'complete':
          return $injector.get('DataIndexSuggestionService');
        case 'off':
          return $injector.get('AlgoliaSuggestionService');
      }
    },
  ])
  .service('DualDispatchSuggestionService', downgradeInjectable(DualDispatchSuggestionService))
  .service('DataIndexSuggestionService', downgradeInjectable(DataIndexSuggestionService))
  .service('AlgoliaSuggestionService', downgradeInjectable(AlgoliaSuggestionService)).name;
